import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/map"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0495 0.384521L6.48432 0.625223L10.0958 2.62442L14.6757 1.05417L16 0.600117V2.00012V12.2858V12.9366L15.4049 13.2002L10.4049 15.4145L9.9505 15.6157L9.51568 15.375L5.90423 13.3758L1.32432 14.9461L0 15.4001V14.0001V3.7144V3.06359L0.595074 2.80005L5.59507 0.585767L6.0495 0.384521ZM2 4.36522V12.6001L5 11.5715V3.03665L2 4.36522ZM9 12.8035L7 11.6964V3.19668L9 4.30383V12.8035ZM11 12.9636L14 11.635V3.40012L11 4.42869V12.9636Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Map16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Map16 = createIcon(IconComponent);